import React from "react";
import PropTypes from "prop-types";

function MediaJobResult({ gid }) {
  return <div>MediaJob: {JSON.stringify(gid)}</div>;
}

MediaJobResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default MediaJobResult;
